import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SimpleSearchComponent } from './simple-search.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [SimpleSearchComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [SimpleSearchComponent]
})
export class SimpleSearchModule { }
